/**
 * Inline notice shown above skeleton loaders so a slow data load reads as
 * "still working" rather than a failed/blank page. Pairs with the animated
 * skeletons on the detail, inventory, sales, and pacing pages.
 */
export function LoadingNotice({
  message = "Loading data — this can take a few seconds…",
}: {
  message?: string;
}) {
  return (
    <div className="flex items-center gap-3 rounded-xl border border-wmp-500/20 bg-wmp-50 px-4 py-3">
      <div className="w-4 h-4 border-2 border-wmp-200 border-t-wmp-500 rounded-full animate-spin flex-shrink-0" />
      <p className="text-sm font-medium text-wmp-700">{message}</p>
    </div>
  );
}
